module.exports = __webpack_public_path__ + "img/saxophone.430151c5.svg";